import React from 'react';
import LayoutWithSidebar from 'components/v2/LayoutWithSidebar';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import LaneRatesEditor from './LaneRatesEditor';

export default function LaneRatesEditPage() {
  const { t } = useTranslation();
  const location = useLocation();
  const params = new URLSearchParams(location?.search);

  console.log('params: ', params);

  const isActionCreate = location.pathname === '/lane-rates/add';
  const breadcrumbs = {
    pages: [
      {
        name: t('LANE_RATES'),
        href: '/lane-rates',
        current: false,
      },
      {
        name: isActionCreate ? t('ADD_LANE_RATE') : t('EDIT_LANE_RATES'),
        current: true,
      },
    ],
  };

  return (
    <main className="py-4">
      <LayoutWithSidebar title={t('LANE_RATES')} breadcrumbs={breadcrumbs}>
        <LaneRatesEditor
          laneRates={location.state?.laneRates}
          isActionCreate={isActionCreate}
        />
      </LayoutWithSidebar>
    </main>
  );
}
